import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { Users, RadioTower, Settings, Handshake } from "lucide-react";
import { Reveal, Arrow, WaIcon } from "./Reveal";
import { WA_LINK } from "./data";

export const Commitment = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const scale = useTransform(scrollYProgress, [0, 1], [1.2, 1]);
  return (
    <section ref={ref} id="galeri" data-testid="commitment-section" className="relative overflow-hidden bg-white">
      <div className="lg:absolute lg:inset-y-0 lg:right-0 lg:w-[62%] h-[340px] sm:h-[440px] lg:h-auto relative overflow-hidden">
        <motion.img style={{ scale }} src="/img/tech.jpg" alt="Teknisi VISION memasang perangkat internet" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t lg:bg-gradient-to-r from-white via-white/0 to-transparent lg:via-white/10" />
        <p data-testid="commitment-tagline" className="glass-tag font-tag uppercase absolute top-5 right-5 max-w-[280px] sm:max-w-[360px] text-right leading-[1.15] text-sm sm:text-lg lg:text-xl">
          <span className="block tag-warm">Internet Murah</span>
          <span className="block text-vnavy">Untuk Masyarakat</span>
          <span className="block tag-gradient">Kalimantan Barat</span>
        </p>
      </div>
      <div className="relative max-w-[1320px] mx-auto px-5 lg:px-10 py-16 lg:py-28">
        <Reveal className="max-w-md">
          <p className="font-display font-bold text-vnavy text-lg">Komitmen Kami</p>
          <h2 className="font-display text-4xl sm:text-5xl font-extrabold text-gradient leading-[1.05] mt-1">Membangun Koneksi untuk Masa Depan</h2>
          <p className="mt-5 text-slate-600 leading-relaxed">VISION MEGA NETWORK hadir untuk memberikan solusi internet yang lebih dekat, merata dan berkelanjutan, mendukung pertumbuhan masyarakat dan dunia usaha di era digital.</p>
          <a href="#kontak" data-testid="about-btn" className="btn-ghost mt-8">Tentang Kami <Arrow /></a>
        </Reveal>
      </div>
    </section>
  );
};

const STATS = [
  { icon: Users, a: "100+", b: "Pelanggan Puas", c: "border-amber-300 text-amber-300" },
  { icon: RadioTower, a: "Area", b: "Berkembang", c: "border-emerald-300 text-emerald-300" },
  { icon: Settings, a: "Teknologi", b: "Terkini", c: "border-sky-300 text-sky-300" },
  { icon: Handshake, a: "Solusi", b: "Terpercaya", c: "border-rose-300 text-rose-300" },
];

export const CTA = () => (
  <section id="kontak" data-testid="cta-section" className="relative bg-vnavy text-white py-20 overflow-hidden">
    <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_20%_100%,rgba(31,139,255,0.35),transparent_55%)]" />
    <div className="relative max-w-[1320px] mx-auto px-5 lg:px-10 grid lg:grid-cols-[1.2fr_1fr] gap-12 items-center">
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-8">
        {STATS.map((s, i) => (
          <Reveal key={s.b} delay={i * 0.08} className="text-center">
            <motion.span whileHover={{ scale: 1.1 }} className={`mx-auto w-16 h-16 rounded-full border-2 ${s.c} grid place-items-center bg-white/5`}>
              <s.icon size={28} />
            </motion.span>
            <p data-testid={`stat-${i}`} className="font-display font-extrabold text-2xl mt-3">{s.a}</p>
            <p className="text-sm text-blue-100">{s.b}</p>
          </Reveal>
        ))}
      </div>
      <Reveal delay={0.15}>
        <div className="relative bg-white text-vnavy rounded-[28px] p-8 shadow-2xl overflow-hidden">
          <div className="absolute -right-16 -bottom-16 w-56 h-56 rounded-full bg-sky-100" />
          <div className="relative">
            <h2 className="font-display text-3xl font-extrabold">Siap Memulai?</h2>
            <p className="text-slate-600 mt-2">Dapatkan internet terbaik untuk kebutuhan Anda sekarang juga.</p>
            <a href={WA_LINK} target="_blank" rel="noreferrer" data-testid="cta-whatsapp-btn" className="btn-wa btn-shine mt-6 inline-flex items-center gap-3">
              <WaIcon className="w-6 h-6" /> Hubungi Kami Sekarang <Arrow />
            </a>
            <p className="mt-4 text-sm font-semibold text-slate-600">WhatsApp: 0852-8000-0955</p>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
